import styled from 'styled-components'

export const LineItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`
